import type { ExperteNameWithGesperrtStatus } from '../dtos';

import { getExperteName } from './getBezeichnungen';
import { unique } from './unique.ts';

export function getVeranstaltungTrainers(blockungen: { experte: ExperteNameWithGesperrtStatus }[]): string[] {
  return blockungen //
    .map((blockung) => getExperteName(blockung.experte))
    .filter(unique);
}
